var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Configuración","active":""}},[_c('config-tab',{attrs:{"configProtocol":_vm.configProtocol},on:{"postDataProtocol":_vm.postDataProtocol}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }